// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// Routing
import { withRouter } from 'react-router-dom';

class BlurProvider extends React.Component {
    render() {
        return (
            <div
                style={{
                    WebkitFilter: this.props.shouldBlur
                        ? 'blur(5px)'
                        : 'blur(0px)',
                    WebkitTransition: 'all 0.5s',
                }}
            >
                {this.props.children}
            </div>
        );
    }
}

const mapStateToProps = ({ blur }) => {
    return {
        shouldBlur: blur.shouldBlur,
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        null,
    )(BlurProvider),
);



// WEBPACK FOOTER //
// ./src/BlurProvider.jsx